var v = (t) => {
  throw TypeError(t);
};
var f = (t, s, e) => s.has(t) || v("Cannot " + e);
var c = (t, s, e) => (f(t, s, "read from private field"), e ? e.call(t) : s.get(t)), l = (t, s, e) => s.has(t) ? v("Cannot add the same private member more than once") : s instanceof WeakSet ? s.add(t) : s.set(t, e), m = (t, s, e, i) => (f(t, s, "write to private field"), i ? i.call(t, e) : s.set(t, e), e), E = (t, s, e) => (f(t, s, "access private method"), e);
import { directive as N, Directive as g, PartType as M } from "../beacon-directive.d/index.js";
const O = {
  skipPreRender: !1
};
var n, h, d, u;
const a = class a extends g {
  constructor(e) {
    super(e);
    l(this, n);
    l(this, h);
    const { type: i, element: o, options: r } = e;
    if (i !== M.ELEMENT || !(o instanceof HTMLSlotElement))
      throw new Error(
        "The `whiteSpaceSensitive` directive must be used on a `<slot>` element."
      );
    if (m(this, n, o), c(this, n).name)
      throw new Error(
        "The `whiteSpaceSensitive` directive should only go on default slots."
      );
    r != null && r.host && m(this, h, r.host);
  }
  render(e) {
    var r;
    const i = Object.assign({ ...O }, e), { skipPreRender: o } = i;
    o || E(r = a, d, u).call(r, c(this, h).childNodes), c(this, n).addEventListener("slotchange", (x) => {
      var T;
      const w = c(this, n).assignedNodes();
      E(T = a, d, u).call(T, w);
    });
  }
};
n = new WeakMap(), h = new WeakMap(), d = new WeakSet(), u = function(e) {
  e.forEach((i) => {
    var o;
    i.nodeType !== Node.COMMENT_NODE && (i instanceof HTMLElement && i.slot || !((o = i.textContent) != null && o.trim()) && i instanceof Text && i.remove());
  });
}, l(a, d);
let p = a;
const S = N(p);
export {
  S as w
};
